<template>
  <md-table-row :md-item="user" class="align-left">
    <md-table-cell><span id="user-name">{{ user.firstname + " " + user.lastname }}</span></md-table-cell>
    <md-table-cell><span id="user-email">{{ user.email }}</span></md-table-cell>
    <md-table-cell>
      <span v-if="user.customers.length === 0" class="not-usable"><translate>Not assigned</translate></span>
      <span v-else>{{ user.customers.join(', ') }}</span>
    </md-table-cell>
    <md-table-cell>
      <translate id="user-active" v-if="user.active">ACTIVE</translate>
      <translate id="user-active" v-else class="not-usable">NOT ACTIVE</translate>
    </md-table-cell>
    <md-table-cell>
      <translate id="user-admin" v-if="user.admin">ADMIN</translate>
      <translate id="user-admin" v-else></translate>
    </md-table-cell>

    <md-dialog md-open-from="#delete-user" md-close-to="#delete-user" ref="dialog">
      <md-dialog-title><translate>Are you sure you want to delete user:</translate></md-dialog-title>
      <md-dialog-content>
        <md-layout md-align="center"><span class="md-headline">{{ user.firstname + " " + user.lastname }}</span></md-layout>
        <md-layout md-align="center" v-if="user.customers.length !== 0 "><br /><translate>Assigned to depot(s): </translate>{{ user.customers.join(', ') }}</md-layout>

      </md-dialog-content>
      <md-dialog-actions>
        <md-button id="close-dialog" class="md-default" @click.native="closeDialog('dialog')"><translate>Cancel</translate></md-button>
        <md-button id="confirm-dialog" class="md-raised md-accent" @click.native="confirmDialog('dialog')"><translate>Delete</translate></md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-table-cell class="cell-icon-container">
      <md-button @click.native="clickEdit(user)" class="md-icon-button">
        <md-icon class="cell-icon">edit</md-icon>
      </md-button>
    </md-table-cell>
    <md-table-cell class="cell-icon-container">
      <md-button id="delete-user" @click.native="openDialog('dialog')" class="md-icon-button">
        <md-icon class="cell-icon">delete</md-icon>
      </md-button>
    </md-table-cell>
  </md-table-row>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'user-row',
  props: [ 'user' ],
  computed: {
    customers () {
      return this.user.customers
    }
  },
  methods: {
    ...mapMutations([
      'userEdit',
      'userToDelete', // add user to state.deleting
      'userCancelDelete'
    ]),
    openDialog (ref) {
      this.$refs[ref].open()
      this.userToDelete(this.user)
    },
    closeDialog (ref) {
      this.$refs[ref].close()
      this.userCancelDelete()
    },
    confirmDialog (ref) {
      this.$refs[ref].close()
      this.$store.dispatch('deleteUsers')
    },
    clickEdit (user) {
      this.$router.push({ name: 'tab-1-edit', params: { id: user._id } })
      this.userEdit(user._id)
    }
  }
}
</script>

<style>
/* force shrink EDIT and DELETE icons */
.cell-icon-container {
  width: 92px;
  padding: 0px;
}
.cell-icon {
  width: 24px !important;
  height: 24px !important;
  margin: auto !important;
  font-size: 22px !important;
}
.align-left {
  text-align: left;
}
.not-usable {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/users/Row.vue